export const PROFILEMGMT_PROFILE_UPDATED = 'PROFILEMGMT_PROFILE_UPDATED';
export const PROFILEMGMT_ADDRESS_RUNNING = 'PROFILEMGMT_ADDRESS_RUNNING';
export const PROFILEMGMT_ADDRESS_CREATED = 'PROFILEMGMT_ADDRESS_CREATED';
export const PROFILEMGMT_ADDRESS_UPDATED = 'PROFILEMGMT_ADDRESS_UPDATED';
export const PROFILEMGMT_ADDRESS_DELTETED = 'PROFILEMGMT_ADDRESS_DELTETED';
